module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAASFBMVEUAAACZmZmAgYV/gYZ+gYV/goaAqqqBgYiAg4Z/goZ+gYV/gYV+goWAgoZ/goWEhIx+goaAg4f///9/goZ+goZ+goaDg4qAhIiFtVO7AAAAGHRSTlMABYbl/4cGTUyz6vPYfpsf8kQBvcDuJT6iOKunAAAAcklEQVR4Ae3PxQHDQBBDUcXz18y0/VcaZj4F/c4Dkp4xC4wrzIXaCLjBacOIdEWMaQN0FXzcQMKR5MmBqebbB1I2slsDbOW3B7RUUN4dqGqaewNtR687A1XHMGrLiM8HiprBa8dxRT9qL3TGiSwvGz1rAWshBf4WzVB8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/e9_doc.png
// module id = QIc2
// module chunks = 1